import { UserCertification } from "../model/certification";
import { api } from "./api";

export const getUserCertifications = async (accessToken: string, programId: string): Promise<UserCertification[]> => {
    const response = await api.get<UserCertification[]>(`/programs/${programId}/certifications`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.data
};